import { render, staticRenderFns } from "./feature-view.vue?vue&type=template&id=16792c52&scoped=true"
import script from "./feature-view.vue?vue&type=script&lang=js"
export * from "./feature-view.vue?vue&type=script&lang=js"
import style0 from "./feature-view.vue?vue&type=style&index=0&id=16792c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16792c52",
  null
  
)

export default component.exports